export default __webpack_public_path__ + "static/nfts-illustration-light-b20340af7690cd09b678578df205c066.svg";